import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useEntityTotals } from '@printdeal/checkout-frontend';
import { Money } from '../../../../Money';
import { SanitizedOrder } from '../../../../../types/order/Order';

interface Props {
  order: SanitizedOrder;
}

const OrderCouponCodes = ({ order }: Props) => {
  // @ts-expect-error type mismatch
  const { entityTotal } = useEntityTotals({ entity: order });

  if (!entityTotal?.couponCodes?.length) {
    return null;
  }

  return (
    <>
      {
        entityTotal.couponCodes.map((couponCode) => (
          <div className="pd-flex pd-gap-4" key={couponCode.code}>
            <div className="pd-flex pd-grow pd-gap-4">
              <div className="pd-w-full pd-font-bold md:pd-w-48">
                <FormattedMessage id="checkout.coupon.labelText" defaultMessage="Coupon" />
              </div>
              <div className="pd-grow">
                {couponCode.code}
              </div>
            </div>
            <div>
              <Money
                value={-couponCode.centAmount}
                currency={couponCode.currencyCode}
              />
            </div>
          </div>
        ))
    }
    </>
  );
};

export default OrderCouponCodes;
